import Loading from 'quasar/src/plugins/loading/Loading.js';
import { defineComponent, ref, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { GetHanyoParam } from "~/api/Common/Commands";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import MyPageNumberInput from "~/components/MyPageNumberInput.vue";
import MyPageTable from "~/components/MyPageTable.vue";
import { auth } from "~/core";
import { Log } from "~/extensions/utils";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { HanyoKb, PageID, userType } from "~/extensions/utils/DefineTypes";
import { HanyoHelper } from "~/extensions/utils/HanyoHelper";
import { PagingListHelper } from "~/extensions/utils/PagingHelper";
import { store } from "~/store/admin/KeiyakushaStore";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("KeiyakushaList");
export default defineComponent({
    components: {
        MyPageTable,
        MyPageNumberInput,
        BreadcrumbList
    },
    name: "keiyakushaList",
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["account-edit"];
        if (!relatedScreens.includes(fromScreen)) {
            store.clear();
        }
        next();
    },
    async setup() {
        const pageName = commonStore.pageName(PageID.keiyakushaList);
        const top = PageID.top;
        const keiyakushaList = PageID.keiyakushaList;
        const router = useRouter();
        const route = useRoute();
        const pagingListHelper = new PagingListHelper({ mode: "store", store }, log);
        let isUpdated = Number(route.query.isUpdated === "true");
        // 契約区分プルダウン
        let userKbList = ref([]);
        // テーブルカラム
        const columns = [
            { name: "editIcon", align: "left", field: "editIcon", sortable: false },
            { name: "userCd", label: "契約者コード", align: "left", field: "userCd", sortable: true },
            { name: "userKb", label: "契約区分", align: "left", field: "userKb", sortable: true, headerStyle: "width: 100px; max-width: 100px" },
            { name: "kankatuKb", label: "管轄区分", align: "center", field: "kankatuKb", sortable: true },
            { name: "userName", label: "契約者名", align: "left", field: "userName", sortable: true, headerStyle: "width: 250px; max-width: 250px" },
            { name: "buknCd", label: "物件コード", align: "left", field: "buknCd", sortable: true },
            { name: "buknName", label: "物件名", align: "left", field: "buknName", sortable: true, headerStyle: "width: 250px; max-width: 250px" },
            { name: "roomNo", label: "号室", align: "left", field: "roomNo", sortable: true },
            { name: "email", label: "メールアドレス", align: "left", field: "email", sortable: true, headerStyle: "width: 200px; max-width: 200px" },
            { name: "loginId", label: "ログインID", align: "left", field: "loginId", sortable: false }
        ];
        const getHanyo = async () => {
            let gethanyoParam = [new GetHanyoParam(HanyoKb.UserKb)];
            let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
            userKbList.value = hanyoList.GetByHanyoKb(HanyoKb.UserKb);
            if (!auth.userInfo.isHeadquarters) {
                store.condition.userKb = { label: userKbList.value.find(n => n.value === 0)?.label ?? "", value: 0 };
            }
        };
        // 初期表示処理
        const initView = async () => {
            try {
                await getHanyo();
            }
            catch (ex) {
                await MsgBox.error(ex.data.errorMessage);
                log.error("find", ex);
            }
        };
        const userKbText = (value) => {
            if (value === userType.Kojin) {
                return "個人";
            }
            if (value === userType.hojin) {
                return "法人";
            }
            return "";
        };
        //検索ボタン押下の処理
        const onSearch = async () => {
            Loading.show();
            store.condition.isSearch = true;
            await pagingListHelper.search();
            Loading.hide();
        };
        // ページング処理
        const onRequest = async (requestData) => {
            Loading.show();
            await pagingListHelper.paging(requestData);
            Loading.hide();
        };
        //行押下時の処理
        const onClick = (userCd) => {
            router.push({ name: "account-edit", query: { userCd: userCd } });
        };
        const onChange = () => {
            store.condition.isSearch = false;
        };
        // アカウント作成/削除/更新直後の場合、ロード処理を実行
        if (isUpdated) {
            await onSearch();
        }
        initView();
        return {
            ...toRefs(store),
            columns,
            expansionState: ref(true),
            userKbList,
            HanyoKb,
            auth,
            pageName,
            top,
            keiyakushaList,
            onSearch,
            onRequest,
            onClick,
            userKbText,
            isNullOrUndefined,
            onChange
        };
    }
});
